// extracted by mini-css-extract-plugin
export default {"weather-container":"Weather_weather-container__nJ3wD","weather-location":"Weather_weather-location__Ar3zJ"};